/* Copy that works when the panel is served over plain HTTP.
 *
 * navigator.clipboard exists ONLY in a secure context — HTTPS, or localhost.
 * This panel is opened on whatever machine is to hand, over http://<lan-ip>,
 * where navigator.clipboard is undefined and the modern call throws with
 * nothing on screen to say why. The button looked dead because it was.
 *
 * So: try the modern API, and fall back to a hidden textarea + execCommand,
 * which is deprecated but still works in exactly the non-secure context the
 * modern one refuses. Returns whether the copy actually happened, so the caller
 * can show "copied" only when it did.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through to the legacy path */
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    // Keep it out of view and out of the layout, but still selectable.
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.setAttribute('readonly', '');
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
